import chart from './gateway_group_stat/chart';
import activity from './gateway_group_stat/activity';
import dataStat from './gateway_group_stat/data_stat';

export default {
  namespaced: true,
  modules: { chart, activity, dataStat }
};
